export function toNum(val: any): number {
  if (val == null) return 0;
  if (typeof val === "number") return val;
  if (typeof val === "string") return parseFloat(val) || 0;
  // NumericValue from Smithy might be an object with a value property
  if (typeof val === "object" && "value" in val)
    return parseFloat(val.value) || 0;
  return Number(val) || 0;
}

export function getLastDayOfPreviousMonth(): string {
  const now = new Date();
  const lastDay = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0),
  );
  return lastDay.toISOString().split("T")[0];
}

export function addMonths(dateStr: string, months: number): string {
  const d = new Date(dateStr + "T00:00:00Z");
  d.setUTCMonth(d.getUTCMonth() + months);
  return d.toISOString().split("T")[0];
}

export function getFirstOfMonth(dateStr: string): string {
  return dateStr.substring(0, 7) + "-01";
}

export const fmt = (v: number) =>
  v.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
